import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos'
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos'
import { Box, Typography } from '@mui/material'
import { createFileRoute, Outlet, useNavigate } from '@tanstack/react-router'
import { useLayoutEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { CustomButton } from '@/shared/ui/button'
import { PageWrapper } from '@/shared/ui/page-wrapper'
import { CustomTab } from '@/shared/ui/tab'
import { CustomTabs } from '@/shared/ui/tabs'

type RouteName = 'common' | 'parameters'

export const Route = createFileRoute(
  '/_auth/canteen/menu-settings/catalog-menu/details/$menuCardId'
)({
  component: RouteComponent,
})

function RouteComponent() {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { menuCardId } = Route.useParams()

  const [tab, setTab] = useState<RouteName>('common')

  const handleBack = () => {
    navigate({ to: '/canteen/menu-settings/catalog-menu' })
  }

  const handleTabChange = (value: RouteName) => {
    setTab(value)
    navigate({
      to: `/canteen/menu-settings/catalog-menu/details/$menuCardId/${value}`,
      params: { menuCardId },
    })
  }

  useLayoutEffect(() => {
    handleTabChange(tab)
  }, [tab])

  return (
    <PageWrapper title={t('Карточка меню')}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: '24px' }}>
        <CustomButton
          size="small"
          color="secondary"
          variant="contained"
          onClick={handleBack}
          startIcon={<ArrowBackIosIcon />}
        >
          {t('Назад')}
        </CustomButton>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <Typography sx={{ fontSize: '14px', color: 'text.secondary' }}>
            {t('Каталог меню')}
          </Typography>
          <ArrowForwardIosIcon sx={{ fontSize: '12px', color: 'text.secondary' }} />
          <Typography>{t('Карточка меню')}</Typography>
        </Box>
      </Box>
      <CustomTabs value={tab} onChange={(_, value) => handleTabChange(value)}>
        <CustomTab label={t('Общие условия')} value="common" />
        <CustomTab label={t('Параметры меню')} value="parameters" />
      </CustomTabs>
      <Outlet />
    </PageWrapper>
  )
}
